const lang = {
  AA: '阿法尔语',
  AB: '阿布哈兹语',
  AF: '南非荷兰语',
  AK: '阿坎语',
  AM: '阿姆哈拉语',
  AR: '阿拉伯语',
  AN: '阿拉贡语',
  AS: '阿萨姆语',
  AV: '阿瓦尔语',
  AE: '阿维斯陀语',
  AY: '艾马拉语',
  AZ: '阿塞拜疆语',
  BA: '巴什基尔语',
  BM: '班巴拉语',
  BE: '白俄罗斯语',
  BN: '孟加拉语',
  BH: '比哈尔语',
  BI: '比斯拉玛语',
  BO: '藏语',
  BS: '波斯尼亚语',
  BR: '布里多尼语',
  BG: '保加利亚语',
  CA: '加泰罗尼亚语',
  CS: '捷克语',
  CH: '查莫罗语',
  CE: '车臣语',
  CU: '古教会斯拉夫语',
  CV: '楚瓦什语',
  KW: '康沃尔语',
  CO: '科西嘉语',
  CR: '克里语',
  CY: '威尔士语',
  DA: '丹麦语',
  DE: '德语',
  DV: '迪维希语',
  DZ: '不丹语',
  EL: '现代希腊语',
  EN: '英语',
  EO: '世界语',
  ET: '爱沙尼亚语',
  EU: '巴斯克语',
  EE: '埃维语',
  FO: '法罗语',
  FA: '波斯语',
  FJ: '斐济语',
  FI: '芬兰语',
  FR: '法语',
  FY: '弗里西亚语',
  FF: '富拉语',
  GD: '苏格兰盖尔语',
  GA: '爱尔兰语',
  GL: '加利西亚语',
  GV: '马恩岛语',
  GN: '瓜拉尼语',
  GU: '古吉拉特语',
  HT: '海地克里奥尔语',
  HA: '豪萨语',
  HE: '希伯来语',
  HZ: '赫雷罗语',
  HI: '印地语',
  HO: '希里莫图语',
  HR: '克罗地亚语',
  HU: '匈牙利语',
  HY: '亚美尼亚语',
  IG: '伊博语',
  IO: '伊多语',
  II: '四川彝语',
  IU: '伊努伊特语',
  IE: '国际语E',
  IA: '拉丁国际语',
  ID: '印尼语',
  IK: '依努庇克语',
  IS: '冰岛语',
  IT: '意大利语',
  JV: '爪哇语',
  JA: '日语',
  KL: '格陵兰语',
  KN: '卡纳达语',
  KS: '克什米尔语',
  KA: '格鲁吉亚语',
  KR: '卡努里语',
  KK: '哈萨克语',
  KM: '高棉语',
  KI: '基库尤语',
  RW: '基尼阿万达语',
  KY: '吉尔吉斯语',
  KV: '科米语',
  KG: '刚果语',
  KO: '朝鲜语',
  KJ: '宽亚玛语',
  KU: '库尔德语',
  LO: '老挝语',
  LA: '拉丁语',
  LV: '拉脱维亚语',
  LI: '林堡语',
  LN: '林加拉语',
  LT: '立陶宛语',
  LB: '卢森堡语',
  LU: '卢巴-加丹加语',
  LG: '干达语',
  MH: '马绍尔语',
  ML: '马拉雅拉姆语',
  MR: '马拉提语',
  MK: '马其顿语',
  MG: '马达加斯加语',
  MT: '马耳他语',
  MN: '蒙古语',
  MI: '毛利语',
  MS: '马来语',
  MY: '缅甸语',
  NA: '瑙鲁语',
  NV: '纳瓦霍语',
  NR: '南恩德贝勒语',
  ND: '北恩德贝勒语',
  NG: '恩敦加语',
  NE: '尼泊尔语',
  NL: '荷兰语',
  NN: '新挪威语',
  NB: '挪威布克莫尔语',
  NO: '书面挪威语',
  NY: '尼扬贾语',
  OC: '奥克语',
  OJ: '奥杰布瓦语',
  OR: '奥利亚语',
  OM: '奥洛莫语',
  OS: '奥塞梯语',
  PA: '旁遮普语',
  PI: '巴利语',
  PL: '波兰语',
  PT: '葡萄牙语',
  PS: '普什图语',
  QU: '凯楚亚语',
  RM: '利托-罗曼语',
  RO: '罗马尼亚语',
  RN: '基隆迪语',
  RU: '俄语',
  SG: '桑戈语',
  SA: '梵语',
  SI: '僧加罗语',
  SK: '斯洛伐克语',
  SL: '斯洛文尼亚语',
  SE: '北萨莫斯语',
  SM: '萨摩亚语',
  SN: '绍纳语',
  SD: '信德语',
  SO: '索马里语',
  ST: '南索托语',
  ES: '西班牙语',
  SQ: '阿尔巴尼亚语',
  SC: '撒丁语',
  SR: '塞尔维亚语',
  SS: '斯瓦特语',
  SU: '巽他语',
  SW: '斯瓦希里语',
  SV: '瑞典语',
  TY: '塔希提语',
  TA: '泰米尔语',
  TT: '塔塔尔语',
  TE: '泰卢固语',
  TG: '塔吉克语',
  TL: '塔加洛语',
  TH: '泰语',
  TI: '提格里尼亚语',
  TO: '汤加语 (汤加岛)',
  TN: '塞茨瓦纳语',
  TS: '宗加语',
  TK: '土库曼语',
  TR: '土耳其语',
  TW: '特威语',
  UG: '维吾尔语',
  UK: '乌克兰语',
  UR: '乌尔都语',
  UZ: '乌兹别克语',
  VE: '文达语',
  VI: '越南语',
  VO: '沃拉普克语',
  WA: '沃伦语',
  WO: '沃洛夫语',
  XH: '科萨语',
  YI: '依地语',
  YO: '约鲁巴语',
  ZA: '壮语',
  ZH: '汉语',
  ZU: '祖鲁语'
};

export default lang;
